<template>
  <div>
    <el-dialog title :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="wid70">
        <div class="col000 font600 font26">Welcome</div>
        <div class="col000 font600 font24">欢迎注册城市好房</div>
        <div class="padtb10">
          <el-input placeholder="请输入手机号或者邮箱" prefix-icon="el-icon-user"  v-model="phone"></el-input>
        </div>
           <div class="padtb10">
          <el-input placeholder="请输入验证码" prefix-icon="el-icon-lock"  v-model="trustPsd">
             <template slot="append"> <span class="col333">获取验证码</span> </template>
          </el-input>
        </div>
           <div class="padtb10">
          <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" :show-password="true" v-model="password"></el-input>
        </div>
        <div class="subbtn">立即注册</div>
        <div class="padtb10">
           已有账号？<span class="colred"> 去登录</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone:'',
      trustPsd:'',
      password:'',
    };
  },
  props: ["dialogVisible"],
  created() {},
  mounted() {},
  watch: {
    dialogVisible(val) {
      console.log(val);
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('close',false)
    }
  }
};
</script>

<style  lang="scss">
.wid70 {
  width: 90%;
  margin: auto;
}
.subbtn{
  width: 100%;
  height: 3rem;
  background: url(../../static/img/btnbg.png)  no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  font-size: 1rem;
  color: #fff;
  line-height:3rem;
  margin-top: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/region.vue